import assign from "lodash/fp/assign";
import moment from "moment";
import constants from "../../core/constants";

class Controller {
  constructor(Events) {
    "ngInject";

    this.Events = Events;
  }

  $onInit() {
    this.enableField = () => {
      this.selected.isDisabled = false;
    };

    this.submitField = () => {
      const formatedValue = Number(
        moment(this.selected.value).format(constants.unixFormat)
      );
      const methodName = this.resourceMethodName;
      const selected = assign(this.selected, {
        value: formatedValue,
        name: this.name,
        key: this.name || this.selected.key,
      });
      const result = assign({ index: this.index, methodName }, selected);

      if (this.extraParams) result.extraParams = this.extraParams;

      this.Events.emit(this.eventName, result);
    };
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/editableTime/editableTime.controller.js